import { Form, FormItemProps } from 'antd';
import { observer } from 'mobx-react-lite';
import { useStores } from '@/hooks/use-stores';
import { useStage } from '../Stage/Provider';

interface AutoSaverFormItemProps extends FormItemProps {
  saveOnChange?: boolean;
}

export const AutoSaverFormItem = observer(
  ({ children, rules, saveOnChange, getValueFromEvent, ...props }: AutoSaverFormItemProps) => {
    const { lifecycleStore } = useStores();
    const { id: stageId } = useStage();

    const rulesWithAutoSaving: FormItemProps['rules'] = [
      ...(rules || []),
      {
        validator: async (_, value) => {
          // Apply getValueFromEvent transformation if provided (e.g., for date formatting)
          const transformedValue = getValueFromEvent ? getValueFromEvent(value) : value;
          await lifecycleStore.updateTask(stageId, props.name, transformedValue);
        },
      },
    ];

    return (
      <Form.Item
        {...props}
        getValueFromEvent={getValueFromEvent}
        rules={rulesWithAutoSaving}
        validateFirst={true}
        validateTrigger={saveOnChange ? ['onChange'] : ['onBlur']}
      >
        {children}
      </Form.Item>
    );
  },
);
